module.exports = __webpack_public_path__ + "static/media/custom-cursor.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Tekentool/assets/custom-cursor.svg
// module id = 74
// module chunks = 0